import './bootstrap';
// import '../css/filament/user/theme.css'; // might be possible to switch these last two css sheets around eventually and pull the users theme into the filament panel.
import '../css/app.css';
import * as Sentry from '@sentry/vue';
import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/index.js';
import Vapor from 'laravel-vapor';
Vapor.withBaseAssetUrl(import.meta.env.VITE_VAPOR_ASSET_URL);
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

window.addEventListener('popstate', (event) => {
    event.stopImmediatePropagation();

    router.reload({
        preserveState: false,
        preserveScroll: false,
        replace: true,
        onSuccess: (page) => router.setPage(page),
        onError: () => (window.location.href = event.state.url)
    });
});

createInertiaApp({
    progress: { color: 'var(--color-500)' },
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });

        app.use(plugin)
            .use(ZiggyVue)
            .mixin({
                methods: {
                    asset: Vapor.asset
                }
            });

        Sentry.init({
            app,
            dsn: sentryDsn,
            sendDefaultPii: true
        });
        return app.mount(el);
    }
});
